import { FC, useEffect, useState } from "react";
import classes from './changeDurationLesson.module.scss'
import { DropDownListSelected } from "../../../shared/ui/dropDownSelected";
import { IItem } from "../../../shared/model/types";
import { Modal } from "../../../shared/ui/modal";
import editImg from '../../../shared/lib/assets/edit.png'
import { MyInput } from "../../../shared/ui/input";
import { MyButton } from "../../../shared/ui/button";
import { MyError } from "../../../shared/lib/error/MyError";
import { AuthError } from "../../../shared/lib/error/AuthError";
import { useMyActions } from "../../../entities/my";
import { useGlobalMessageActions } from "../../../entities/globalMessage";
import { useGlobalLoadingActions } from "../../../entities/globalLoading";
import { studentService } from "../../../entities/student";
import { ConfirmationAction } from "../../../shared/ui/confirmationAction";
import {
    createUtcDateFromMoscowDateTimeInput,
    formatMoscowDateTimeInput,
    formatUtcDateTime,
    parseUtcDateTime,
} from "../../../shared/lib/helpers/moscowDateTime";

interface IProps{
    durationInit: string;
    dateInit: string;
    lessonId: number;
    setData: (date: string, duration: number) => void;
}

const convertUtcToMskInput = (value: string) => {
    return formatMoscowDateTimeInput(parseUtcDateTime(value))
}

const DURATION_OPTIONS = [
    {id: 1, name: '1 час', value: '60'},
    {id: 2, name: '1.5 часа', value: '90'},
    {id: 3, name: '2 часа', value: '120'},
]

const convertMskInputToUtc = (value: string) => {
    const utcDate = createUtcDateFromMoscowDateTimeInput(value)
    if(!utcDate) return null

    return formatUtcDateTime(utcDate)
}

export const ChangeDurationLesson: FC<IProps> = ({lessonId, durationInit, dateInit, setData}) => {
    const [open, setOpen] = useState<boolean>(false)
    const [date, setDate] = useState<string>(convertUtcToMskInput(dateInit))
    const [selected, setSelected] = useState<number>(DURATION_OPTIONS.find(v => v.value === durationInit)?.id || DURATION_OPTIONS[0].id)
    const {setIsAuth} = useMyActions()
    const {setGlobalMessage} = useGlobalMessageActions()
    const {setIsLoading} = useGlobalLoadingActions()
    const [confirm, setConfirm] = useState<boolean>(false)
    const [error, setError] = useState<string>('')

    useEffect(() => {
        setSelected(DURATION_OPTIONS.find(v => v.value === durationInit)?.id || DURATION_OPTIONS[0].id)
        setDate(convertUtcToMskInput(dateInit))
    }, [open, durationInit, dateInit])

    const onSelected = (item: IItem) => {
        return (s: boolean) => {
            if(s){
                setSelected(item.id)
            }
        }
    }

    const onChange = async () => {
        const utcDate = convertMskInputToUtc(date)

        if(!utcDate){
            setError('Неправильный формат даты')
            return
        }

        try{
            setIsLoading(true)
            onClose(false)
            const newDuration = DURATION_OPTIONS.find(v => v.id === selected)?.value || durationInit
            await studentService.changeLesson(lessonId, utcDate, +newDuration)
            setData(utcDate, +newDuration)
            setGlobalMessage({message: 'Успешное редактирование занятия', type: 'ok'})
        }
        catch(e){
            console.log(e)
            if(e instanceof AuthError){
                setIsAuth(false)
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else if(e instanceof MyError){
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else{
                setGlobalMessage({message: 'Ошибка при редактировании занятия', type: 'error'})
            }
        }
        finally{
            setIsLoading(false)
        }
    }

    const onClose = (open: boolean) => {
        if(!open){
            setConfirm(false)
        }
        setOpen(open)
    }

    const isValidDateTimeFormat = (str: string): boolean => {
        return Boolean(convertMskInputToUtc(str));
    };

    const onCheckDate = () => {
        if(!isValidDateTimeFormat(date)){
            setError('Неправильный формат даты')
            return
        }
        setConfirm(true)
    }

    return (
        <section className={classes.container}>
            <img src={editImg} alt="Редактировать занятие" onClick={() => setOpen(true)} />
            <Modal open={open} setOpen={onClose}>
                {
                    confirm
                        ?
                    <ConfirmationAction
                        title="Точно хотите изменить длительность или дату занятия?"
                        setOpen={onClose}
                        onClick={onChange}
                        type="send"
                    />
                        :
                    <section className={classes.change}>
                        <section className={classes.date}>
                            <span>Дата в формате<span>&nbsp;"YYYY-MM-DD HH:MM:SS" (мск)</span></span>
                            <MyInput
                                value={date}
                                setValue={setDate}
                                setError={setError}
                            />
                        </section>
                        <DropDownListSelected
                            items={DURATION_OPTIONS}
                            selectedIdItems={[selected]}
                            onSelected={onSelected}
                            isLoading={false}
                        />
                        <section className={classes.button}>
                            <MyButton
                                onClick={onCheckDate}
                                error={error}
                            >
                                Изменить
                            </MyButton>
                        </section>
                    </section>
                }
            </Modal>
        </section>
    )
}
